import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import { Loader } from "../Loader";

// `alsoAllow` es una vía de acceso ADITIVA (OR) al gate primario (allowedRoles ∧ allowedIds):
// recibe { rol, id, pais } y, si devuelve true, concede acceso aunque no pase el gate primario.
// Se usa para gatear por país sin ensanchar el gate por-id (FASE 1 ER v2 en Chile). `deniedIds`
// sigue teniendo prioridad sobre ambas vías.
const PrivateRoute = ({ children, allowedRoles, allowedIds = null, deniedIds = null, alsoAllow = null }) => {
  const { session, rol, id, pais, isLoading } = useAuthContext();

  if (isLoading || session === undefined) {
    return <Loader fullPage />;
  }

  const hasAllowedRole = allowedRoles.includes(rol);
  const hasAllowedId = allowedIds ? allowedIds.includes(id) : true;
  const isDenied = deniedIds ? deniedIds.includes(id) : false;

  if (isDenied) {
    return <Navigate to="/admin" replace />;
  }

  const passesPrimary = hasAllowedRole && hasAllowedId;
  const passesAlso = alsoAllow ? alsoAllow({ rol, id, pais }) : false;

  if (!session || (!passesPrimary && !passesAlso)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
